// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-largeOnWide-superElipse-4a0df755","strokeWidth":"super-ellipse-skins-largeOnWide-strokeWidth-82dc792c"};